import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrencyCompact, formatPercentage } from '@/utils/formatters';

interface WaterfallSummaryCardProps {
  title: string;
  amount: number;
  percentage?: number;
  subtitle?: string;
  currency: string;
  className?: string;
  isSelected?: boolean;
  onClick?: () => void;
}

export function WaterfallSummaryCard({
  title,
  amount,
  percentage,
  subtitle,
  currency,
  className = '',
  isSelected,
  onClick,
}: WaterfallSummaryCardProps) {
  return (
    <Card
      className={`shadow-sm ${className} ${onClick ? 'cursor-pointer hover:border-primary/50 transition-colors' : ''} ${isSelected ? 'ring-2 ring-primary border-primary' : ''}`}
      onClick={onClick}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">
          {formatCurrencyCompact(amount, currency)}
        </div>
        {percentage !== undefined && (
          <p className="text-xs text-muted-foreground mt-1">
            {formatPercentage(percentage, 1)} Allocation
          </p>
        )}
        {subtitle && (
          <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
        )}
      </CardContent>
    </Card>
  );
}
